import { AuthenticationService } from "../authentication.service";
import { HOST_CONFIG, HostConfig } from "src/app/config/AppInitializer.factory";
import { Inject, Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { getValueIfPropertyExists } from "src/app/utils/helper";

@Injectable({
  providedIn: 'root',
})
export class ApiClientConfig {

    constructor(
        private authenticationService: AuthenticationService,
        @Inject(HOST_CONFIG) private hostConfig: HostConfig
    ) {}

    getBaseUrl(): string {
        return this.hostConfig.ebrApiUrl;
    }

    async getHeaders(): Promise<{ [key: string]: string }> {
        const onBehalfOf = this.authenticationService.onBehalfOf;
        const accessToken = await this.authenticationService.getAccessToken();
        const configurationKeyLabel: string | null = getValueIfPropertyExists<any, string | null>(environment, 'configurationKeyLabel', null);
        const headers = {
            ...{
                Accept: '*/*',
                Authorization: `Bearer ${accessToken}`,
            },
            ...(onBehalfOf != null && {
                'On-Behalf-Of': onBehalfOf,
            }),
            ...(configurationKeyLabel != null && {
                'X-Configuration-Key-Label': configurationKeyLabel,
            }),
        };

        return headers;
    }
}
